export class HotDocsQnA {
    responseId: number;
    engagementId: number;
    templateName: string;
    questionVariable: string;
    questionText: string
    answerText: string;
    typeOfQuestion: string;
    workspaceId: string;
}

export class HotDocsQnaModal {
    workspaceId: string;
    hotDocsQna: HotDocsQnA[];
    engagementId: number;
}